// Traduções pt-BR do desconto por indicação do GetPaid. Paridade total com
// referral.en.ts (a fonte da verdade) — toda chave existe nos dois arquivos.
const referral: Record<string, string> = {
  // Prompt pré-onboarding
  'referral.prompt.title': 'Tem um código de indicação?',
  'referral.prompt.pitch':
    'Adicione agora e ganhe 50% de desconto na nossa tarifa nos primeiros 30 dias de pagamentos.',
  'referral.prompt.dismiss': 'Não tenho um código',
  'referral.prompt.active':
    'Desconto por indicação ativo — 50% de desconto na nossa tarifa no seu primeiro mês',
  'referral.prompt.activeUntil':
    'Desconto por indicação ativo — 50% de desconto na nossa tarifa no seu primeiro mês, até {date}',

  // Cartão permanente de indicação (adicionar / bloqueado)
  'referral.card.title': 'Adicionar código de indicação',
  'referral.card.pitch':
    'Adicione agora e ganhe 50% de desconto na nossa tarifa nos primeiros 30 dias de pagamentos.',
  'referral.card.placeholder': 'Código de indicação',
  'referral.card.apply': 'Aplicar',
  'referral.card.lockedTitle': 'Código de indicação',
  'referral.card.lockedBody':
    'Código de indicação adicionado em {date}. Isso nunca pode ser alterado.',
  'referral.card.lockedBodyNoDate':
    'Há um código de indicação registrado. Isso nunca pode ser alterado.',

  // Erros compartilhados ao aplicar (400 / 409)
  'referral.error.invalid': 'Esse código não é válido.',
  'referral.error.selfReferral': 'Você não pode usar seu próprio código de indicação.',
  'referral.error.alreadySet': 'Já existe um código de indicação registrado nesta conta.',
  'referral.error.generic': 'Não foi possível adicionar esse código. Tente novamente.',
};

export default referral;
